import {instance} from "../../../config/axios-cnf";

export const apiGetDashboardInfo = (subjectId, callback, error) => {
    instance.get("/api/v2/enigoo/" + subjectId + "/dashboard/info")
        .then(response => callback(response.data))
        .catch(err => error(err))
}

export const apiGetDashboardDevices = (subjectId, callback, error) => {
    instance.get("/api/v2/enigoo/" + subjectId + "/dashboard/devices")
        .then(response => callback(response.data))
        .catch(err => error(err))
}
